<template>
  <div class='pc-add-tags'>
    <div class="pc-bp-tab-schoolManager">
      <h2>{{ typeTagArgs.title }}标签管理</h2>
      <div>
        <button
          @click="tagManager"
          v-show="managerState == false"
          class="pc-search-clickBtn"
        >
          管理
        </button>
        <button
          @click="tagManagerSave"
          v-show="managerState"
          class="pc-search-clickBtn"
        >
          完成
        </button>
      </div>
    </div>
    <!-- 院校标签管理 -->
    <div class="pc-bp-tab-location">
      <div
        v-for="(item, index) in typeTagList"
        :key="index"
        class="pc-bp-tab-location-type"
      >
        <div class="pc-bp-tab-location-title">
          <h4 v-show="tagTitle != index">{{ item.name }}</h4>
          <el-input
            v-show="tagTitle == index"
            @blur="searchOnBlur(item.name, item.type)"
            v-model="item.name"
            label-width="100px"
          ></el-input>
          <!-- 修改标签 -->
          <i
            v-show="managericon"
            @click="updateArea(index)"
            class="el-icon-edit icon-area"
          ></i>
          <i
            v-show="managericon"
            @click="isdeleteTagType(item.id)"
            class="el-icon-delete icon-area"
          ></i>
        </div>
        <ul>
          <li
            v-for="(items, indexs) in item.tags"
            :key="indexs"
            :class="managerState ? 'managerClass' : ''"
          >
            <span>{{ items.name }}</span>
            <i
              v-show="managerState"
              @click="removeTypeTag(items.id, index)"
              class="el-icon-close"
            ></i>
          </li>
          <li @click="addAreaTag(item.id)"><span>添加标签</span></li>
        </ul>
      </div>
      <div @click="addTypeTag" v-show="managerState" class="addType">
        <i class="el-icon-circle-plus-outline"></i>
        <span>添加分类</span>
      </div>
    </div>
    <!-- 面板 -->
    <div
      v-show="searchTemplete"
      @click="hideSearch"
      class="search-templete"
    ></div>
    <!-- 提示框 -->
    <DeleteDialog
      @isDelete="isDelete"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delid="deleteId"
      :delContent= delContent
    />
    <!-- 添加标签的模态框 -->
    <el-dialog :visible.sync="dialogFormVisible">
      <el-input v-model="addTagName" label-width="100px"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="choiceAdd()">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
// 功能模板
import DeleteDialog from "./DeleteDialog";
import {
  getTagTypes,
  addTag,
  addTagType,
  updateTagType,
  deleteTagType,
  deleteTag,
} from "./graphql/typeTag.gql";
export default {
  props: { typeTagArgs: Object },
  components: {
    DeleteDialog,
  },
  data() {
    return {
      typeTagList: [],
      // templateTagTypeArgs:{name:'',type:'',c},
      tagTypeArgs: {
        name: "分类",
        type: "BP",
      },
      delContent:null,
      // 新增小标签
      addTagNameArgs: {
        name: "",
        tagTypeId: "",
      },
      // tagTitle
      tagTitle: "-1",
      // 添加标签
      addTagName: "",
      // manager 修改显示的
      managerState: false,
      // manager 修改显示的icon
      managericon: false,
      // 底色模板
      searchTemplete: false,
      // 管理标签的模块
      dialogFormVisible: false,
      // 修改标签选择的Id
      updateTagId: "",
      // 删除面板的显示隐藏
      deleteShow: false,
      // 删除面板的Id
      deleteId: "-1",
      // 判断当前删除的是父标签还是子标签
      checkDeleteTagType: "",
    };
  },
  mounted() {
    this.getTagTypes();
    // this.
  },
  methods: {
    getTagTypes() {
      this.$global
        .GraphqlQuery(this, getTagTypes, this.typeTagArgs)
        .then((res) => {
          // console.log("res:", res);
          this.typeTagList = res.data;
        });
    },
    // 管理标签
    tagManager() {
      this.managerState = true;
      this.managericon = true;
      this.managerAwardsState = false;
    },
    // 管理标签的保存按钮
    tagManagerSave() {
      this.managerState = false;
      this.managericon = false;
    },
    // 添加大分类
    addTypeTag() {
      let num = Number(this.typeTagList.length) + 1;
      let name = "分类" + num;
      this.tagTypeArgs.name = name;
      this.tagTypeArgs.type = this.typeTagArgs.type;
      this.$global
        .GraphqlMutation(this, addTagType, {
          // Parameters
          data: this.$global.checkNull(this.tagTypeArgs),
        })
        .then((res) => {
          this.$emit('refresh')
          this.getTagTypes();
          
        });
    },
    // 添加地名标签
    addAreaTag(id) {
      this.addTagNameArgs.tagTypeId = id;
      this.dialogFormVisible = true;
    },
    // 添加小标签
    choiceAdd() {
      this.addTagNameArgs.name = this.addTagName;
      this.$global
        .GraphqlMutation(this, addTag, {
          // Parameters
          data: this.$global.checkNull(this.addTagNameArgs),
        })
        .then((res) => {
          
          this.getTagTypes();
          this.dialogFormVisible = false;
          this.addTagName = null
          this.$emit('refresh')
        });
    },
    // 修改所在地名字
    updateArea(index) {
      this.tagTitle = index;
      this.updateTagId = this.typeTagList[index].id;
      this.searchTemplete = true;
      this.managericon = false;
    },
    // 隐藏输入框
    hideSearch() {
      this.searchTemplete = false;
      this.managericon = true;
      this.tagTitle = -1;
    },
    searchOnBlur(name, type) {
      this.tagTypeArgs.name = name;
      this.tagTypeArgs.type = type;
      this.$global
        .GraphqlMutation(this, updateTagType, {
          id: this.updateTagId,
          data: this.$global.checkNull(this.tagTypeArgs),
        })
        .then((res) => {
          console.log("成功了吗", res);
          this.$emit('refresh')
        });
    },

    // 移除该分类类型标签（移除大标签）
    isdeleteTagType(id) {
      this.checkDeleteTagType = "one";
      this.delContent = "删除该分类时将同时删除该分类下的所有标签，是否确认删除？"
      this.deleteId = id;
      this.deleteShow = true;

    },
    // 移除该分类标签(移除小标签)
    removeTypeTag(id, index) {
      this.checkDeleteTagType = "two";
      this.deleteId = id;
      this.delContent = null
      this.deleteShow = true;
      this.$emit('refresh')
      // this.tag[index].tagList.splice(indexs, 1);
    },
    isCancel() {
      this.deleteShow = false;
    },
    isDelete(id) {
      if (this.managerState == true && this.checkDeleteTagType == "two") {
        this.$global
          .GraphqlMutation(this, deleteTag, {
            id: id,
          })
          .then((res) => {
            this.getTagTypes();
            this.$emit('refresh')
          });
      } else if (
        this.managerState == true &&
        this.checkDeleteTagType == "one"
      ) {
        console.log("isone", id);
        this.$global
          .GraphqlMutation(this, deleteTagType, {
            id: id,
          })
          .then((res) => {
            this.getTagTypes();
            this.$emit('refresh')
          });
      }
      this.deleteShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-add-tags{
   box-shadow: $boxshadow;
    padding: 30px 35px 20px;
    margin-top: 40px;
}
// 模块
.search-templete {
  width: 100vw;
  height: 100vh;
  background: black;
  position: fixed;
  top: 0;
  opacity: 0;
}
.pc-bp-tab-schoolManager {
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $border-color;
  padding-bottom: 15px;
  > h2 {
    font-size: 20px;
    color: $mainTitle;
    align-self: flex-end;
  }
  .pc-search-clickBtn {
    position:relative;
    top:-10px;
    width: 90px;
    height: 40px;
    margin-bottom:-10px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
}
.pc-bp-tab-location {
  margin-top: 20px;
  .pc-bp-tab-location-title {
    display: flex;
    height: 20px;
    h4 {
      // margin-top: 20px;
      font-size: 14px;
      color: $mainTitle;
    }
    .icon-area {
      margin-left: 10px;
      // margin-top: 20px;
      color: $timeBtn;
      cursor: pointer;
    }
    .icon-area:nth-of-type(2) {
      margin-left: 5px !important;
    }
    /deep/ .el-input {
      margin-top: 20px;
      width: auto;
      //  .el-input__inner{width: 70px;}
    }
  }
  ul {
    margin-top: 10px;
    display: flex;
    li {
      min-width: 70px;
      text-align: center;
      padding: 8px 21px;
      border: 1px solid $universityBorder;
      background: $universityBackground;
      margin-right: 20px;
      margin-bottom: 20px;
      color: $timeBtn;
      font-family: $english;
      border-radius: 4px;
      .el-icon-close {
        margin-left: 5px;
      }
    }
    li:last-child {
      border: 1px dashed $timeBtn;
      background: none;
      cursor: pointer;
    }
    .managerClass {
      transition: transform 0.3s;
    }
    .managerClass:hover {
      transform: translateY(-10px);
      cursor: pointer;
    }
  }
  .pc-bp-tab-location-type {
    .pc-bp-tab-location-title {
      display: flex;

      h4 {
        // margin-top: 20px;
        font-size: 14px;

        color: $mainTitle;
      }
      .icon-area {
        margin-left: 10px;
        // margin-top: 20px;
        color: $timeBtn;
        cursor: pointer;
      }
      /deep/ .el-input {
        margin-top: 20px;
        z-index: 20;
        width: auto;
        //  .el-input__inner{width: 70px;}
      }
    }
    ul {
      flex-wrap: wrap;
      li {
        margin-bottom: 20px;
        span{font-size: 14px;}
      }
    }
  }
  .addType {
    margin-top: 10px;
    margin-bottom: 20px;
    cursor: pointer;
    .el-icon-circle-plus-outline {
      font-size: 20px;
      color: $blueBtna;
    }
    span {
      font-size: 14px;
      text-align: center;
    }
  }
}
.el-dialog__body{
    display: flex;
    justify-content: center;
}
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__footer {
    padding: 10px 25% 30px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
      .el-button--default{

      }
       .el-button--default:hover{
         span{color: $blueBtna}
       }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/template/Tag.vue